export class PrefixedClassList {
  private classNames: string[];

  constructor(private prefix: string, ...classNames: string[]) {
    this.classNames = classNames;
  }

  toString(): string {
    return this.toArray().join(' ');
  }

  toArray(): string[] {
    return this.classNames.map((className) => `${this.prefix}${className}`);
  }
}
